import { toast } from '../../common_components/Toast/ToastUtils';
import XLSX from 'xlsx-js-style';
import { NETWORK_LABEL_MAP } from '../../utils/networkConstants';
const titleStyle = {
    font: { bold: true, sz: 20, color: { rgb: '181D27' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const columnHeaderStyle = {
    font: { bold: true, sz: 11, color: { rgb: '374151' } },
    fill: { fgColor: { rgb: 'E5E7EB' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const formatCurrency = (value) => {
    const num = Number(value) || 0;
    return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};
const formatGrowth = (value) => {
    if (value === null || value === undefined)
        return '0%';
    return `${(Number(value) || 0).toFixed(2)}%`;
};
const formatRoas = (value) => {
    const num = Number(value) || 0;
    return num ? num.toFixed(2) : '0';
};
/**
 * Export the Affiliate Monthly Projection table to XLSX. Columns mirror the on-screen table.
 */
export function exportAffiliateProjection(rows, meta) {
    if (!rows || !Array.isArray(rows) || rows.length === 0) {
        toast.info('No data available to export');
        return;
    }
    try {
        const targetLabel = meta?.year_month_label || 'PROJ';
        const baseYear = meta?.base_year_month?.split('-')[0] || meta?.base_year_month_label || 'BASE';
        const headers = [
            'Store Id', 'Store Name', 'Outreach', 'Intro to AM', 'Conv. Rate', 'Conversations', 'Published',
            'Site Prev. Year Rev', 'Site YOY Growth Rate', 'Site Measurement Channel', 'Site Proj Rev',
            `Prev. Year Rev (${baseYear})`, 'YOY Growth Rate', 'Measurement Channel', 'Proj Rev', 'Proj ROAS', 'AM Projection',
            'Actual Revenue', 'Actual Spend', 'Actual Roas', 'Account Manager', 'Type', 'Site Goal', 'Clockify Goal', 'Notes',
        ];
        const data = rows.map((row) => [
            row.legacy_id ?? '',
            row.client_name || '',
            row.aff_outreach || 0,
            row.aff_intro_am || 0,
            `${row.aff_conv_rate || 0}%`,
            row.aff_conversations || 0,
            row.aff_published || 0,
            formatCurrency(row.site_base_revenue),
            formatGrowth(row.site_yoy_growth_rate),
            row.site_measurement_channel || '',
            formatCurrency(row.site_projected_revenue),
            formatCurrency(row.mc_base_revenue),
            formatGrowth(row.mc_yoy_growth_rate),
            (row.measurement_channels || []).map((n) => NETWORK_LABEL_MAP[n] || n).join(', '),
            formatCurrency(row.mc_projected_revenue),
            formatRoas(row.projected_roas),
            formatCurrency(row.am_projection),
            formatCurrency(row.actual_revenue),
            formatCurrency(row.actual_spend),
            formatRoas(row.actual_roas),
            row.account_manager || '',
            row.account_type || '',
            row.aff_site_goal ? formatCurrency(row.aff_site_goal) : '',
            row.clockify_goal || 0,
            row.notes || '',
        ]);
        const numCols = headers.length;
        const titleText = `Monthly Projection (Affiliate)${targetLabel ? ` - ${targetLabel}` : ''}`;
        const titleRow = [titleText, ...Array(numCols - 1).fill('')];
        const spacerRow = Array(numCols).fill('');
        const sheetData = [titleRow, spacerRow, headers, ...data];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        if (worksheet['A1'])
            worksheet['A1'].s = titleStyle;
        worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];
        for (let c = 0; c < numCols; c++) {
            const headerCell = XLSX.utils.encode_cell({ r: 2, c });
            if (worksheet[headerCell])
                worksheet[headerCell].s = columnHeaderStyle;
        }
        worksheet['!cols'] = [
            { wch: 10 }, { wch: 24 }, { wch: 10 }, { wch: 11 }, { wch: 10 }, { wch: 13 }, { wch: 10 },
            { wch: 18 }, { wch: 18 }, { wch: 22 }, { wch: 20 },
            { wch: 16 }, { wch: 16 }, { wch: 24 }, { wch: 18 }, { wch: 11 }, { wch: 16 },
            { wch: 16 }, { wch: 15 }, { wch: 12 }, { wch: 22 }, { wch: 12 }, { wch: 14 }, { wch: 14 }, { wch: 18 },
        ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Affiliate Projection');
        const safeMonth = meta?.year_month?.replace('-', '_') || 'projection';
        XLSX.writeFile(workbook, `Affiliate_Projection_${safeMonth}.xlsx`);
    }
    catch (error) {
        console.error('Affiliate export failed:', error);
        toast.info('Failed to export. Please try again.');
    }
}
export default exportAffiliateProjection;
